var React = require('react');

function HelpingHand (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 60L32.48 39.52C34.7283 37.2689 37.7785 36.0028 40.96 36H52C54.1217 36 56.1566 36.8429 57.6569 38.3431C59.1571 39.8434 60 41.8783 60 44C60 46.1217 59.1571 48.1566 57.6569 49.6569C56.1566 51.1571 54.1217 52 52 52H42M58 49.28L74.68 29.72C75.9687 28.2916 77.7558 27.4114 79.6737 27.2604C81.5915 27.1095 83.4943 27.6994 84.9905 28.9086C86.4868 30.1179 87.4626 31.8547 87.7174 33.7615C87.9721 35.6684 87.4863 37.6004 86.36 39.16L69.56 62.92C68.4601 64.4783 67.0047 65.752 65.3143 66.6354C63.6239 67.5189 61.7473 67.9867 59.84 68H39.32C38.2644 67.9992 37.219 68.2073 36.2441 68.6123C35.2693 69.0173 34.3842 69.6113 33.64 70.36L28 76M8 56L32 80","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

HelpingHand.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = HelpingHand;

HelpingHand.default = HelpingHand;
